import { Injectable } from '@angular/core';
import { NetworkService } from '../shared/network.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private networkService: NetworkService) { }
  // validateLogin(req: any) {
  //   return this.networkService.login("api/admin/login", req, null, null);
  // }
  validateLogin(req: any) {
    return this.networkService.login("api/company/login", req, null, null);
  }
  createCompany(req: any) {
    return this.networkService.login("api/company", req, null, null);
  }
  validateInviteCode(id: any) {
    return this.networkService.get("api/inviteCode/"+id, null, null, null);
  }

      
  uploadImage(image: any) {
    const formData = new FormData();

    formData.append("image", image, 'image.jpg');
    return this.networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }
  

}



